import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ComingFreeData } from '../../../interfaces/metrics';

@Component({
  selector: 'bst-company-coming-free',
  templateUrl: './company-coming-free.component.html',
  styleUrls: ['./company-coming-free.component.scss'],
  standalone: false,
})
export class CompanyComingFreeComponent {
  @Input() data!: ComingFreeData;
  @Output() rowSelected = new EventEmitter<{ userId: number; name: string }>();

  get rows() { return this.data?.rows ?? null; }

  select(row: { userId: number; name: string }): void {
    this.rowSelected.emit({ userId: row.userId, name: row.name });
  }

  // Same bands as bst-suggested-vacancies' getScoreColor, so a score reads the same
  // color everywhere it appears.
  matchScoreBand(score: number | null): string {
    if (score === null) return 'basic';
    if (score >= 80) return 'high';
    if (score >= 50) return 'med';
    if (score > 0) return 'low';
    return 'basic';
  }
}
